module.exports = __webpack_public_path__ + "img/student.a3af6ee0.svg";